export default __webpack_public_path__ + "static/media/amico.ab83f9fc.png";